import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AnimatePresence, motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import SidebarMenu from "./SidebarMenu";
import '../../assets/styles/sidebar.css';
import { api_urls } from "../../utils/api-urls";
import { RouteName } from "../../utils/route-name";

const showAnimation = {
  hidden: { width: 0, opacity: 0, transition: { duration: 0.5 } },
  show: { opacity: 1, width: "auto", transition: { duration: 0.5 } },
};

const SideBar = () => {
  const dispatch = useDispatch();
  const { isSidebarOpen } = useSelector(state => state?.dashboard);

  const [hiddenSidebarWidth, setHiddenSidebarWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) setHiddenSidebarWidth(55);
      else setHiddenSidebarWidth(0);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [adminPermission, setAdminPermission] = useState(["Dashboard", "Astrologer", "Services History", "Astro Mall", "Astro Puja", "User", "New Users", "Notifications", "Utilities", "Sub Admin", "Banner", "Category", "Sub Category", "Yatra", "Sanchar", "Religious", "Transaction", "Operator Images", "Flight Images", "Static Pages", "TBO Bookings", "Milan Sathi", "Reports", "App Errors", "Post Banao", "Rojgar", "Vendor Management", "Marketplace", "Sanatani Manch", "Roles & Logs", "Issue Control", "Home Sections", "Payment Gateways", "Sanatani Sadan", "Grow", "All Transactions", "Fraud Blocks"]);
  const [detailedPerms, setDetailedPerms] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    const localUserId = localStorage.getItem('userId');
    const userType = localStorage.getItem('userType');
    if (localUserId) setUserId(localUserId);
    if (userType === 'admin') setIsAdmin(true);

    const getPermission = async () => {
      const { data } = await axios.post(`${api_urls}api/admin/getPermissions`, { id: userId })
      if (userType === 'admin') return
      else {
        setAdminPermission(data?.results?.permission || data?.results?.permissions)
        setDetailedPerms(data?.results?.detailedPermissions || [])
      }
    };

    userId && getPermission();
  }, [userId]);

  // Filter sub-routes based on detailed permissions (for sub-admins)
  const getFilteredRoute = (route) => {
    // Admin users see everything
    if (isAdmin || !route.subRoutes) return route;
    // No detailed permissions = show all sub-routes (backward compatibility)
    if (!detailedPerms || detailedPerms.length === 0) return route;

    const allowedSubs = detailedPerms
      .filter(p => p.module === route.name && p.subModule && (p.view || p.add || p.edit || p.delete))
      .map(p => p.subModule);

    // If no sub-module permissions found for this module, show all (old format backward compat)
    if (allowedSubs.length === 0) return route;

    return {
      ...route,
      subRoutes: route.subRoutes.filter(sr => allowedSubs.includes(sr.name))
    };
  };

  return (
    <>
      <motion.div className={`sidebar`} animate={{ width: isSidebarOpen ? "250px" : `${hiddenSidebarWidth}px` }}>
        <section className="routes">
          {RouteName.filter(route => !route.hidden).map((route, index) => {
            const permittedData = adminPermission && adminPermission.find(curr => curr === route?.name)

            if (permittedData === route.name && route.subRoutes) {
              const filteredRoute = getFilteredRoute(route);
              if (filteredRoute.subRoutes && filteredRoute.subRoutes.length > 0) {
                return (
                  <SidebarMenu route={filteredRoute} key={index} showAnimation={showAnimation} />
                );
              }
              return null;
            }

            return (
              <div key={index} className={`${permittedData == route.name ? 'side_Bar' : 'display-none'}`} >
                <NavLink to={permittedData == route.name && route.path} className='link' activeclassname="active">
                  <div className='icon'>{route.icon}</div>

                  <AnimatePresence>
                    {isSidebarOpen && (
                      <motion.div className='link_text' variants={showAnimation} initial="hidden" animate="show" exit="hidden">
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              </div>
            );
          })}
        </section>
      </motion.div>
    </>
  );
};

export default SideBar;
